import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCRIPT_ID = 'ask-embed-script';
const WIDGET_CONTAINER_ID = 'ask-widget';
const WIDGET_STYLES_ID = 'ask-styles';

const ASK_ID = import.meta.env.VITE_ASK_ID;
const ASK_SCRIPT_SRC = import.meta.env.VITE_ASK_SCRIPT_SRC;
const API_URL = import.meta.env.VITE_API_URL;

const LANGUAGE_PREFIXES = ['de', 'fr', 'es', 'pt', 'zh', 'th', 'ar'];

function isDashboardPath(pathname: string): boolean {
  // Strip optional language prefix, then check for /account
  const stripped = LANGUAGE_PREFIXES.reduce(
    (acc, lang) =>
      acc.startsWith(`/${lang}/`) || acc === `/${lang}` ? acc.slice(lang.length + 1) || '/' : acc,
    pathname
  );
  return stripped === '/account' || stripped.startsWith('/account/');
}

function mountWidget() {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = `${ASK_SCRIPT_SRC}/embed.min.js`;
  script.setAttribute('data-bot-id', ASK_ID as string);
  script.setAttribute('data-api-url', API_URL as string);
  script.async = true;
  document.body.appendChild(script);
}

function unmountWidget() {
  document.getElementById(SCRIPT_ID)?.remove();
  document.getElementById(WIDGET_CONTAINER_ID)?.remove();
  document.getElementById(WIDGET_STYLES_ID)?.remove();
}

export function AskChatWidget() {
  const { pathname } = useLocation();
  const enabled = Boolean(ASK_ID && ASK_SCRIPT_SRC && API_URL);

  useEffect(() => {
    if (!enabled) return;
    if (isDashboardPath(pathname)) {
      unmountWidget();
    } else {
      mountWidget();
    }
  }, [enabled, pathname]);

  useEffect(() => {
    return () => {
      if (enabled) unmountWidget();
    };
  }, [enabled]);

  return null;
}
